/**
 * The links the WhatsApp QR step opens.
 *
 * The QR carries wa.me, which a phone camera hands to the WhatsApp app. A click on a computer used
 * to open the same link, which stops at WhatsApp's own "Open app / Continue to WhatsApp Web" page
 * before the chat — an extra click per message. WhatsApp Web's own link goes straight into the chat
 * with the message drafted, so a computer uses that. A phone keeps wa.me: WhatsApp Web does not run
 * there, and wa.me opens its app.
 */

const text = (message: string | undefined, prefix: string) =>
  message ? `${prefix}text=${encodeURIComponent(message)}` : '';

/** The universal link for a number (digits only) with an optional message — what the QR carries. */
export function waMeLink(phone: string, message?: string): string {
  return `https://wa.me/${phone}${text(message, '?')}`;
}

/** WhatsApp Web's own link: straight into the chat with the message drafted, no page in between. */
export function whatsAppWebChatLink(phone: string, message?: string): string {
  return `https://web.whatsapp.com/send?phone=${phone}${text(message, '&')}`;
}

/** A phone (coarse pointer, narrow screen), where WhatsApp Web does not run. */
export function looksLikePhone(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return !!window.matchMedia?.('(pointer: coarse)').matches && window.innerWidth < 768;
  } catch {
    return false;
  }
}

/** What a click opens: WhatsApp Web's chat on a computer, wa.me on a phone. */
export function chatLinkForClick(phone: string, message?: string, onPhone: boolean = looksLikePhone()): string {
  return onPhone ? waMeLink(phone, message) : whatsAppWebChatLink(phone, message);
}
